import React from 'react';
import carSvg from '../../../../../../../assets/images/car.svg';
import { Card, CardBody, Col } from 'reactstrap';
import { ArrowDown, ArrowUp } from 'react-feather';
import CountUp from 'react-countup';

const ApprovalCard = ({ item, handleClick, isSelected, cardData }) => {
  const totalCount =
    cardData?.[item?.name]?.data?.totalCount || cardData?.[item?.name]?.data?.totalCount === 0
      ? Number(cardData?.[item?.name]?.data?.totalCount)
      : null;

  return (
    <Col key={item.id} sm="6" md="4" lg="4" xl="4" className="approval-col cursor-pointer d-inline-block" onClick={() => handleClick(item)}>
      <Card className={`text-center h-100 approval-card ${isSelected && 'active'} m-0`}>
        <div className="d-flex justify-content-between align-items-start px-4 pe-4 pt-4">
          <img src={item?.icon ? item?.icon : carSvg} className="icon-style" />
          <div>
            <p className="fw-semibold fs-20 m-0 text-end">{item?.displayName}</p>
            {totalCount != null ? (
              <p className="fw-bold fs-24 m-0 text-end">
                <CountUp separator="" start={0} end={totalCount} duration={2} />
              </p>
            ) : (
              <p className="fw-bold fs-24 m-0 text-end">-</p> // Showing dash when data is missing
            )}
            <div className="d-flex gap-2 pb-2">
              {item.trend !== 0 && (
                <div className={`d-flex align-items-center justify-content-center ${item.trend > 0 ? 'text-success' : 'text-danger'}`}>
                  {item.trend > 0 ? <ArrowUp size={14} /> : <ArrowDown size={14} />}
                  <span className="ms-1 fw-semibold">{Math.abs(item.trend ?? 0)}%</span>
                </div>
              )}
              <small className="text-muted">Since Yesterday</small>
            </div>
          </div>
        </div>
      </Card>
    </Col>
  );
};

export default ApprovalCard;
